import { PAPEIS_DA_ADEGA, PAPEL_DESCRICOES, PAPEL_LABELS, type PapelDaAdega } from '@adega/shared';

/**
 * Para que a adega serve.
 *
 * Nasceu de uma correção do usuário: a adega de madeira dele, sem
 * climatização, não é um lugar ruim de guardar — é onde ficam os vinhos que
 * ele vai abrir em seguida. Sem este campo, a análise encurtava a janela de
 * garrafas que saem de lá em duas semanas, repreendendo um uso que está certo.
 *
 * Como na climatização, não existe opção "não informado": o estado inicial já
 * é esse, e um botão para voltar a "não sei" confunde mais do que ajuda.
 */
export function EscolhaPapel({
  valor,
  onChange,
  disabled,
}: {
  valor: PapelDaAdega | null;
  onChange: (valor: PapelDaAdega) => void;
  disabled?: boolean;
}) {
  return (
    <div role="radiogroup" aria-label="Para que serve esta adega" className="space-y-2">
      {PAPEIS_DA_ADEGA.map((opcao) => {
        const selecionada = valor === opcao;
        return (
          <button
            key={opcao}
            type="button"
            role="radio"
            aria-checked={selecionada}
            disabled={disabled}
            onClick={() => onChange(opcao)}
            className={`w-full rounded-xl border p-3 text-left transition disabled:opacity-60 ${
              selecionada
                ? 'border-adega-gold/60 bg-adega-gold/10'
                : 'border-white/10 bg-adega-surface-2'
            }`}
          >
            <span className={`block text-sm font-medium ${selecionada ? 'text-adega-gold' : ''}`}>
              {PAPEL_LABELS[opcao]}
            </span>
            <span className="mt-0.5 block text-xs leading-relaxed text-adega-muted">
              {PAPEL_DESCRICOES[opcao]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
